module.exports = __webpack_public_path__ + "img/会泽县中医医院.345beaf9.png";